import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import { round } from 'lodash';
import { Map } from 'mapbox-gl';
import { useContext, useEffect, useState } from 'react';
import { CtxDebug } from 'session/ctxDebug';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const DebugSection = (props: Props): JSX.Element => {
    const ctxDebug = useContext(CtxDebug);
    const ctxEdit = useContext(CtxEdit);

    const [zoom, setZoom] = useState<number>(ctxEdit.mapRef?.current?.getZoom() ?? 0);

    useEffect(() => {
        function updateZoom(e: { target: Map }) {
            setZoom(e.target.getZoom());
        }

        ctxEdit.mapRef?.current?.on('zoom', updateZoom);
    });

    return (
        <S_DebugSection className={props.className}>
            <SidebarSection
                title={Localization.CURRENT_VIEW_INFO}
                icon={{ iconName: 'circle-info' }}
            >
                <SidebarContent withHover={true} withTopPadding={true}>
                    <SidebarSectionRow hasBorder title={Localization.CURRENT_ZOOM}>
                        {round(zoom, 2)}
                    </SidebarSectionRow>
                    {ctxDebug.coordinates?.lat && ctxDebug.coordinates?.lng && (
                        <SidebarSectionRow hasBorder title={Localization.LAST_CLICK}>
                            Lat: {round(ctxDebug.coordinates.lat, 6)}
                            <br />
                            Lng: {round(ctxDebug.coordinates.lng, 6)}
                        </SidebarSectionRow>
                    )}
                </SidebarContent>
            </SidebarSection>
        </S_DebugSection>
    );
};

const S_DebugSection = styled.div``;
